import { useEffect } from 'react'
import { PRICED_SERVICE_TYPE } from '../settings'

export const useServiceListFiltersEffects = ({
  setValue,
  onFilterChange,
  recurrenceType,
  recurrenceFrequency,
  recurrenceOption,
  measure,
  material,
  action,
  businessLine,
  method,
  pricingPeriod,
  pricingZone,
  isRecurring,
  currentTab,
}) => {
  // When filtering by On-Request services, hide and clear recurrence-specific filters
  useEffect(() => {
    if (recurrenceType === PRICED_SERVICE_TYPE.ON_REQUEST) {
      // Clear values so they don't affect the DataGrid filtering behind the scenes
      setValue('serviceList.recurrenceFrequency', '', { shouldValidate: false })
      setValue('serviceList.recurrenceOption', null, { shouldValidate: false })
    }
  }, [recurrenceType, setValue])

  useEffect(() => {
    const newFilterItems = []

    if (recurrenceType) {
      const recurrenceValues = Array.isArray(recurrenceType) ? recurrenceType : [recurrenceType]

      if (recurrenceValues.length > 0) {
        newFilterItems.push({
          field: 'serviceType',
          operator: 'isAnyOf',
          value: recurrenceValues,
          id: `serviceType-filter`,
        })
      }
    }

    if (isRecurring && recurrenceFrequency !== null && recurrenceFrequency !== undefined && recurrenceFrequency !== '') {
      newFilterItems.push({
        field: 'recurrenceFrequency',
        operator: '=',
        value: recurrenceFrequency,
        id: `recurrenceFrequency-filter`,
      })
    }

    if (isRecurring && recurrenceOption) {
      newFilterItems.push({
        field: 'recurrenceInterval',
        operator: 'isAnyOf',
        value: [recurrenceOption.value],
        id: `recurrenceInterval-filter`,
      })
    }

    if (measure && measure.length > 0) {
      newFilterItems.push({
        field: 'measureText',
        operator: 'isAnyOf',
        value: measure.map(v => v.value),
        id: `measure-filter`,
      })
    }

    if (material && material.length > 0) {
      newFilterItems.push({
        field: 'materialType',
        operator: 'isAnyOf',
        value: material.map(v => v.value),
        id: `material-filter`,
      })
    }

    if (action && action.length > 0) {
      newFilterItems.push({
        field: 'actionType',
        operator: 'isAnyOf',
        value: action.map(v => v.value),
        id: `action-filter`,
      })
    }

    if (method && method.length > 0) {
      newFilterItems.push({
        field: 'methodType',
        operator: 'isAnyOf',
        value: method.map(v => v.label),
        id: `method-filter`,
      })
    }

    if (businessLine && businessLine.length > 0) {
      newFilterItems.push({
        field: 'businessLine',
        operator: 'isAnyOf',
        value: businessLine.map(v => v.value),
        id: `businessLine-filter`,
      })
    }

    if (pricingPeriod && pricingPeriod.length > 0) {
      newFilterItems.push({
        field: 'pricingPeriod',
        operator: 'isAnyOf',
        value: pricingPeriod.map(v => v.value),
        id: `pricingPeriod-filter`,
      })
    }

    if (pricingZone && pricingZone.length > 0) {
      newFilterItems.push({
        field: 'zoneName',
        operator: 'isAnyOf',
        value: pricingZone.map(v => v.value),
        id: `pricingZone-filter`,
      })
    }

    if (onFilterChange) {
      onFilterChange({ items: newFilterItems })
    }
  }, [
    recurrenceType,
    recurrenceFrequency,
    recurrenceOption,
    measure,
    material,
    action,
    businessLine,
    method,
    pricingPeriod,
    pricingZone,
    onFilterChange,
    currentTab,
    isRecurring,
  ])
}
